export default async element => { // [slide-open]
    
    const alias = element.getAttribute('slide-open');
    if (!alias)
        console.warn('An alias needs to be provided for [slide-open]');

    const hiddenContainer = document.getElementById(`hiddenCopy-${alias}`);
    if (!hiddenContainer)
        console.warn(`A hidden element with the id of [hiddenCopy-${alias}] needs to be provided`);

    const openIcon = document.getElementById(`toggleIcon-${alias}`);
    const closeIcon = document.getElementById(`toggleCloseIcon-${alias}`);

    element.addEventListener('click', (event) => {
        event.preventDefault();
        
        if (hiddenContainer.classList.contains("tw-hidden")) {
            hiddenContainer.classList.remove("tw-hidden");
            hiddenContainer.classList.add("tw-block");
            if (openIcon) {
                openIcon.classList.add("tw-hidden");
            }
            if (closeIcon) {
                closeIcon.classList.remove("tw-hidden");
            }
        }
        else if (hiddenContainer.classList.contains("tw-block")) {
            hiddenContainer.classList.remove("tw-block");
            hiddenContainer.classList.add("tw-hidden");
            if (openIcon) {
                openIcon.classList.remove("tw-hidden");
            }
            if (closeIcon) {
                closeIcon.classList.add("tw-hidden");
            }
        }
    });
};